import { PhoneMockup } from "@/components/lunar/PhoneMockup";
import { Reveal } from "@/components/lunar/Reveal";

const SHOTS = [
    {
        number: "01",
        label: "The room",
        src: "/assets/screens/network-room-lunar.webp",
        alt: "Lunar Network app — The room showing professionals open to meeting",
        testId: "network-strip-phone-1-room",
    },
    {
        number: "02",
        label: "Conversations",
        src: "/assets/screens/network-conversations-lunar.webp",
        alt: "Lunar Network app — your professional conversations and connections",
        testId: "network-strip-phone-2-conversations",
    },
    {
        number: "03",
        label: "The chat",
        src: "/assets/screens/network-chat-lunar.webp",
        alt: "Lunar Network app — a professional chat after connecting",
        testId: "network-strip-phone-3-chat",
    },
];

export const NetworkVisualStrip = () => (
    <section
        data-testid="network-visual-strip-section"
        className="mx-auto max-w-6xl overflow-x-hidden px-6 py-12 sm:py-16"
    >
        <Reveal>
            <div
                data-testid="network-visual-strip-grid"
                className="flex snap-x snap-mandatory gap-6 overflow-x-auto pb-4 md:grid md:grid-cols-3 md:overflow-visible md:pb-0"
            >
                {SHOTS.map((shot, i) => (
                    <figure
                        key={shot.label}
                        data-testid={`network-strip-item-${i + 1}`}
                        className="min-w-[236px] snap-center md:min-w-0"
                    >
                        <figcaption className="mb-4 flex items-baseline justify-center gap-2 text-center">
                            <span className="font-display text-xl font-medium text-[#899B6A]">
                                {shot.number}
                            </span>
                            <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#4A5D23]">
                                {shot.label}
                            </span>
                        </figcaption>
                        <div className="mx-auto w-fit">
                            <PhoneMockup
                                src={shot.src}
                                alt={shot.alt}
                                testId={shot.testId}
                                compact
                            />
                        </div>
                    </figure>
                ))}
            </div>
        </Reveal>
    </section>
);
